import { fieldIsValid } from 'modules/Inquiry/Form/formConditions';
import { OTHER_PRODUCT_DESCRIPTION } from 'modules/Inquiry/Form/formFields';

export const validateOtherProductSection = (form) =>
  fieldIsValid(OTHER_PRODUCT_DESCRIPTION)({ form });
